export const ADD_PATIENT = 'ADD_PATIENT';